import { useQuery } from '@tanstack/react-query';
import { CustomFont, FontListResponse, listFonts } from 'src/api/fontApi';

export const useCustomFonts = () => {
   return useQuery<CustomFont[]>({
      queryKey: ['custom-fonts'],
      queryFn: async () => {
         const res = await listFonts();
         const data = res?.data as FontListResponse | CustomFont[] | undefined;
         if (!data) return [];
         if (Array.isArray(data)) return data;
         return data.entities ?? [];
      },
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
   });
};
